<div class="pagination">
  <ul class="pagination__pages">
    <li class="page">
      <lds-button
        appearance="default"
        [isDisabled]="currentPage === 1"
        (onClick)="goto(1)"
        >&lt;&lt;
      </lds-button>
    </li>
    <li class="page">
      <lds-button
        appearance="default"
        [isDisabled]="currentPage === 1"
        (onClick)="goto(currentPage - 1)"
        >&lt;</lds-button
      >
    </li>
    <li class="page" *ngFor="let p of pages">
      <lds-button
        [appearance]="currentPage === p ? 'secondary' : 'default'"
        (onClick)="goto(p)"
        >{{ p }}</lds-button
      >
    </li>
    <li class="page">
      <lds-button
        appearance="default"
        [isDisabled]="currentPage === totalNoOfPages || totalNoOfPages === 0"
        (onClick)="goto(currentPage + 1)"
        >&gt;</lds-button
      >
    </li>
    <li class="page">
      <lds-button
        appearance="default"
        [isDisabled]="currentPage === totalNoOfPages || totalNoOfPages === 0"
        (onClick)="goto(totalNoOfPages)"
        >&gt;&gt;</lds-button
      >
    </li>
  </ul>
</div>
